import { useEffect, useState } from "react";

const CLOCKS: Array<{ label: string; zone: string }> = [
  { label: "UTC", zone: "UTC" },
  { label: "Johannesburg", zone: "Africa/Johannesburg" },
  { label: "Brisbane", zone: "Australia/Brisbane" },
  { label: "New York", zone: "America/New_York" },
  { label: "London", zone: "Europe/London" },
];

function formatClock(now: Date, zone: string) {
  const time = new Intl.DateTimeFormat("en-GB", {
    timeZone: zone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(now);
  const date = new Intl.DateTimeFormat("en-GB", {
    timeZone: zone,
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(now);
  return { time, date };
}

export function WorldClocks() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="admin-clocks" role="group" aria-label="World clocks">
      {CLOCKS.map(({ label, zone }) => {
        const { time, date } = formatClock(now, zone);
        return (
          <div key={zone} className="admin-clock">
            <span className="admin-clock-label">{label}</span>
            <span className="admin-clock-time">{time}</span>
            <span className="admin-clock-date">{date}</span>
          </div>
        );
      })}
    </div>
  );
}
